if (!XMLHttpRequest.prototype.sendAsBinary) {
  XMLHttpRequest.prototype.sendAsBinary = function (sData) {
    let nBytes = sData.length
    let ui8Data = new Uint8Array(nBytes)
    for (let nIdx = 0; nIdx < nBytes; nIdx++) {
      ui8Data[nIdx] = sData.charCodeAt(nIdx) & 0xff;
    }
    /* send as ArrayBufferView...: */
    this.send(ui8Data);
    /* ...or as ArrayBuffer (legacy)...: this.send(ui8Data.buffer); */
  };
}

const createRequest = (cb) => {
  let request = new XMLHttpRequest()

  request.onreadystatechange = () => {
    if (request.readyState === XMLHttpRequest.DONE) {
      if (request.status === 200) {
        let response = JSON.parse(request.responseText)
        typeof cb === 'function' && cb(response)
      } else {
        console.info(request.status)
      }
    }
  }

  return request
}

const upload = (url, file, name) => {
  return new Promise((resolve) => {
    let boundary = '----' + Date.now().toString(16)
    let reader = new FileReader()
    let request = createRequest(resolve)

    reader.onloadend = function () {
      let data = '--' + boundary + '\r\n' +
        `Content-Disposition: form-data; name="${name}"; filename="${file.name}"\r\n` +
        `Content-Type: ${file.type}\r\n` +
        '\r\n' +
        reader.result +
        '\r\n' +
        '--' + boundary + '--\r\n'

      request.sendAsBinary(data)
    }

    request.open('POST', url)
    request.withCredentials = true
    request.setRequestHeader('Content-Type', 'multipart/form-data; boundary=' + boundary)
    reader.readAsBinaryString(file)
  })
}

export default upload



// WEBPACK FOOTER //
// ./src/api/upload.js